export const LISTING_CONDITION_OPTIONS = [
    {
        label: "Sealed",
        value: "SEALED",
    },
    {
        label: "Graded",
        value: "GRADED",
    },
    {
        label: "Raw",
        value: "RAW",
    },
];

export const BOX_CONDITION_OPTIONS = [
    {
        label: "Perfect",
        value: "SEMPURNA",
    },
    {
        label: "Damaged",
        value: "CACAT",
    },
    {
        label: "No Box",
        value: "NO_BOX",
    },
];

export const STOCK_STATUS_OPTIONS = [
    {
        label: "KA Stock",
        value: "KA_STOCK",
    },
    {
        label: "Seller Stock",
        value: "SELLER_STOCK",
    },
];
